import type { SingleValue } from '@ksyos/design-system';
import type { JSX } from 'react';
import { Col, FormGroup, IconButton, Row, Select } from '@ksyos/design-system';
import type { IOption } from '@frontend/components/interfaces/option';
import { getSelectedLanguage } from '@frontend/translate';

interface IServiceOrganizationRoleDistributionRoleSelectProps {
    handleChangeOrganization: (selectedOption: SingleValue<IOption<string>>) => void;
    handleDeleteOrganization: () => void;
    isRequired?: boolean;
    options: IOption<string>[];
    selectedOption: SingleValue<IOption<string>>;
}

export function ServiceOrganizationRoleDistributionRoleSelect(
    props: IServiceOrganizationRoleDistributionRoleSelectProps
): JSX.Element {
    return (
        <FormGroup
            isRequired={props.isRequired}
            label={getSelectedLanguage().organization.organization}
        >
            <Row
                align="center"
                columnGap={2}
            >
                <Col span={11}>
                    <Select
                        noOptionsMessage={() =>
                            getSelectedLanguage().serviceOrganizationSettingRoleDistributions
                                .noPartnerOrganizationsAvailable
                        }
                        onChange={(value) => props.handleChangeOrganization(value)}
                        options={props.options}
                        value={props.selectedOption}
                    />
                </Col>
                <Col span={1}>
                    <IconButton
                        icon="delete"
                        onClick={props.handleDeleteOrganization}
                    />
                </Col>
            </Row>
        </FormGroup>
    );
}
